// import React from 'react'
// import styled from 'styled-components'

// const WhatsApp = () => {
//   const fullNumber = `9190528 81819`;
//   const shareText = encodeURIComponent(
//   // "Found a secret to saving big every time I shop – it's called Bakpoket!  Get real-time coupons, mega discounts & exclusive offers across all categories.  Why pay more? Start saving today  https://bakpoket.com"
//   // "Bakpoket helps shoppers save big with real-time deals while empowering merchants to boost sales through exclusive offers in https://bakpoket.com"
//   'Hello!'
//   );

//   return (
//     <Wrapper>
//       <a
//         // href={`https://wa.me/?text=${shareText}`}
//         href={`https://wa.me/${fullNumber}?text=${shareText}`}
//         target="_blank"
//         rel="noopener noreferrer"
//         aria-label="Share on WhatsApp"
//       >
//         <img src="/images/whatsapp-icon.png" alt="WhatsApp Icon" />
//       </a>
//     </Wrapper>
//   )
// }

// const Wrapper = styled.section`
//   img {
//     position: fixed;
//     bottom: 6rem;
//     right: 2rem;
//     // width: 60px;
//     // height: 60px;
//     cursor: pointer;
//     z-index: 1000;
//   }

//   @media (max-width: 768px) {
//     img {
//       width: 40px;
//       height: 40px;
//       bottom: 6rem;
//       right: 2.4rem;
//     }
//   }
// `

// export default WhatsApp


import React from 'react'
import styled from 'styled-components'

const WhatsApp = () => {
  const fullNumber = `919052881819`; // Correct format
  const shareText = encodeURIComponent('Hello!');

  return (
    <Wrapper>
      <a
        href={`https://wa.me/${fullNumber}?text=${shareText}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on WhatsApp"
      >
        <img src="/images/whatsapp-icon.png" alt="WhatsApp Icon" />
      </a>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  img {
    position: fixed;
    bottom: 6rem;
    right: 2rem;
    cursor: pointer;
    z-index: 1000;
  }

  @media (max-width: 768px) {
    img {
      width: 40px;
      height: 40px;
      bottom: 6rem;
      right: 2.4rem;
    }
  }
`

export default WhatsApp
